let config = {};
if (process.env.VUE_APP_BUILD_PRODUCTION != null) {
  // production config here
  config = {
    authURL: "https://authservercb.ipraticocloud.com",
    apiURL: "https://openlistapi.ipraticocloud.com/",

    mapsAPIKey: "AIzaSyAFkniaEsfTc0mrQaQIGVs9FWM30QtEfQQ",

    oauthClientSecret: "ipratico"
  };
} else {
  // staging config here
  config = {
    authURL: "https://authserverdev.ipraticocloud.com",
    apiURL: "https://bookinglistdev.ipraticocloud.com/",

    mapsAPIKey: "AIzaSyAFkniaEsfTc0mrQaQIGVs9FWM30QtEfQQ",

    oauthClientSecret: "ipratico"
  };
}

export default config;
